import { SecurityInfo, SymbolType } from '../../../../../domain/symbol.domain';
import { OptionQuoteParams } from '../../../../../domain/trading.domain';
import {
  PriceType,
  EquityOrderAction,
  OptionOrderAction,
  Strategy,
  MultiLegOrderDayType,
  PricePlan,
  OrderRequest,
  OrderItem,
  LegExtendedTerms
} from '../../../domain';
import {
  MultilegItemFormModel
} from '../../domain/order-entry.domain';

export abstract class MultilegService {

  static getAllowedOptionActionTypes(optionCode: number): Array<OptionOrderAction> {
    switch (optionCode) {
      case 1: // TODO get rid of magic numbers
        return [
          OptionOrderAction.BUY_TO_OPEN,
          OptionOrderAction.SELL_TO_CLOSE];
      case 2:
      case 3:
        return [
          OptionOrderAction.BUY_TO_OPEN,
          OptionOrderAction.SELL_TO_OPEN_COVERED,
          OptionOrderAction.BUY_TO_CLOSE,
          OptionOrderAction.SELL_TO_CLOSE];
      case 4:
        return [
          OptionOrderAction.BUY_TO_OPEN,
          OptionOrderAction.SELL_TO_OPEN_COVERED,
          OptionOrderAction.SELL_TO_OPEN_UNCOVERED,
          OptionOrderAction.BUY_TO_CLOSE,
          OptionOrderAction.SELL_TO_CLOSE];
      default:
        return [];
    }
  }

  static getAllowedEquityActionTypes(isShortMarginAccount: boolean): Array<EquityOrderAction|OptionOrderAction> {
    return isShortMarginAccount ?
      [OptionOrderAction.BUY_TO_COVER, OptionOrderAction.SHORT_SELL] :
      [EquityOrderAction.BUY, EquityOrderAction.SELL];
  }

  // TODO convert view-model into object and refactor into .convertModelToRequest(vm)
  static convertModelToRequest(accountId: string,
                               selectedType: SymbolType.EQUITY | SymbolType.OPTION,
                               underlyingSymbol: SecurityInfo,
                               firstLeg: MultilegItemFormModel,
                               secondLeg: MultilegItemFormModel,
                               goodTill: MultiLegOrderDayType,
                               goodTillDate: Date,
                               pricePlan: PricePlan,
                               limitPrice: number): OrderRequest {
    const order = [
      this.getLegRequest(firstLeg.orderQuantity,
        firstLeg.orderAction,
        selectedType,
        underlyingSymbol,
        firstLeg.id,
        firstLeg.optionQuoteParams),
      this.getLegRequest(secondLeg.orderQuantity,
        secondLeg.orderAction,
        SymbolType.OPTION,
        underlyingSymbol,
        secondLeg.id,
        secondLeg.optionQuoteParams)
    ];
    return {
      orderTerms: {
        strategy: Strategy.MLO,
        order,
        accountInfo: {
          accountId
        },
        pricePlan,
        afterMarket: false,
        multilegEntry: {
          extendedTerms: {
            goodTill,
            goodTillDate,
            limitPrice
          }
        }
      },
      conditionFilter: 'STANDARD'
    };
  }

  private static getLegRequest(quantity: number,
                               action: EquityOrderAction | OptionOrderAction,
                               selectedType: SymbolType.EQUITY | SymbolType.OPTION,
                               underlyingSymbol: SecurityInfo,
                               id?: string,
                               optionQuoteParams?: OptionQuoteParams): OrderItem<LegExtendedTerms> {
    return {
      id,
      quantity,
      extendedTerms: {
        orderType: PriceType.LIMIT,
        orderAction: action,
        allOrNone: false
      },
      clientInfo: {
        insiderInfo: null,
        solicited: false
      },
      security: {
        type: selectedType,
        market: underlyingSymbol.market,
        symbol: underlyingSymbol.symbol,
        displayTicker: selectedType === SymbolType.OPTION ? optionQuoteParams.displayTicker : undefined
      }
    };
  }

}

